export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/0c7f90dcab4574f291a5b93f31621815.svg";